import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonMessageWidget } from '@eforall/common';
import { ScheduleViewerPart } from '../../../schedule/schedule-viewer/schedule-viewer.part';
import { VolunteerDialogDataService } from '../volunteer-dialog-data.service';

@Component({
	selector: 'volunteer-schedule-part',
	standalone: true,
	imports: [
		ScheduleViewerPart,
		CommonMessageWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './schedule.part.html',
})
export class VolunteerSchedulePart {

	private readonly dialogDataService = inject(VolunteerDialogDataService);

	readonly volunteerDetails = computed(() => this.dialogDataService.volunteerDetails());

}